import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import panel from "./panel";
import { getAuthStorage } from "../../../api/service-localstorage";
import { mapState } from 'vuex';
export default {
  components: {
    panel: panel
  },
  data: function data() {
    return {
      version: 'standard',
      isTrialUser: true
    };
  },
  created: function created() {
    var _getAuthStorage = getAuthStorage(),
        sysVersionInfo = _getAuthStorage.sysVersionInfo,
        version = _getAuthStorage.version;

    this.version = version;
    this.isTrialUser = sysVersionInfo === 0;
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    timeliness: function timeliness(state) {
      return state.timeliness;
    }
  })), {}, {
    typeName: function typeName() {
      if (this.version === 'standard') {
        return '标准版会员';
      } else if (this.version === 'speciality') {
        return '专业版会员';
      } else if (this.version === 'enjoy') {
        return '尊享版会员';
      } else {
        return '定制平台';
      }
    }
  })
};